import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

/**
 * Einheitlicher Empty-State: Icon + genau ein Satz + optionaler CTA.
 * Ein Pattern für alle Listen/Boards (Tickets, Kanban, Fahrtenbuch,
 * Benachrichtigungen …) statt drei verschiedener Stile.
 */
export function EmptyState({
  icon: Icon,
  message,
  hint,
  action,
  className,
}: {
  icon?: LucideIcon
  message: string
  hint?: string
  /** Genau ein CTA (z.B. <Button>) — optional. */
  action?: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 px-6 py-12 text-center',
        className,
      )}
    >
      {Icon && <Icon className="h-8 w-8 text-text-tertiary/50" aria-hidden="true" />}
      <p className="text-sm text-text-tertiary">{message}</p>
      {hint && <p className="text-xs text-text-tertiary/70">{hint}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
